import React from 'react';
import PropTypes from 'prop-types';
import { TextField, Box } from '@mui/material';
import { PageType } from '../../../catalogs/pageCatalog.generated';
import DescribedField from '../DescribedField';

/**
 * ContactBlockEditor — Editor do bloco Contato
 * TODO 4.16
 *
 * Props:
 *   - value: { phone, whatsapp, email, website }
 *   - onChange: (patch) => void
 *   - context: { siteType } — PageType enum int (1=LinkInBio, 2=Professional, 3=Company)
 */
const ContactBlockEditor = ({ value = {}, onChange, context = {} }) => {
  const {
    phone = '',
    whatsapp = '',
    email = '',
    website = '',
  } = value;

  const patch = (field, val) => onChange({ ...value, [field]: val });

  const isProSite = context.siteType === PageType.Professional;

  return (
    <DescribedField
      label="Informações de contato"
      description="Telefone, WhatsApp, e-mail e site para exibição em seção dedicada na página. Campos vazios não aparecem. Em páginas profissionais, os valores-padrão vêm do cadastro de Profissionais — você pode sobrescrever aqui para exibir um contato diferente somente nesta página."
      helperLink={isProSite ? { entity: 'professional' } : undefined}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        <TextField
          fullWidth
          label="Telefone"
          value={phone}
          onChange={(e) => patch('phone', e.target.value)}
          size="small"
          placeholder="(11) 99999-9999"
          helperText="Número de telefone exibido. Vazio oculta o item."
        />
        <TextField
          fullWidth
          label="WhatsApp"
          value={whatsapp}
          onChange={(e) => patch('whatsapp', e.target.value)}
          size="small"
          placeholder="(11) 99999-9999"
          helperText="Número do WhatsApp. Vazio oculta o ícone."
        />
        <TextField
          fullWidth
          label="E-mail"
          value={email}
          onChange={(e) => patch('email', e.target.value)}
          size="small"
          type="email"
          placeholder="contato@exemplo.com.br"
          helperText="E-mail de contato. Vazio oculta o item."
        />
        <TextField
          fullWidth
          label="Site"
          value={website}
          onChange={(e) => patch('website', e.target.value)}
          size="small"
          type="url"
          placeholder="https://www.exemplo.com.br"
          helperText="URL do site. Vazio oculta o item."
        />
      </Box>
    </DescribedField>
  );
};

ContactBlockEditor.propTypes = {
  value: PropTypes.shape({
    phone: PropTypes.string,
    whatsapp: PropTypes.string,
    email: PropTypes.string,
    website: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  context: PropTypes.shape({
    siteType: PropTypes.string,
  }),
};

export default ContactBlockEditor;
